import { render, staticRenderFns } from "./tabSwiper-nav.vue?vue&type=template&id=5e307564&scoped=true&"
import script from "./tabSwiper-nav.vue?vue&type=script&lang=js&"
export * from "./tabSwiper-nav.vue?vue&type=script&lang=js&"
import style0 from "./tabSwiper-nav.vue?vue&type=style&index=0&id=5e307564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e307564",
  null
  
)

export default component.exports